<p class="text-center">Are you sure you would like to deactivate your account?</p>
<p class="text-center btn-row">
  <button class="btn btn-primary" (click)="deactivateAccount()" [disabled]="isLoading">
    Confirm
    <i class="fa fa-circle-o-notch fa-spin" *ngIf="isLoading"></i>
  </button>
  <button class="btn btn-white" (click)="cancelDeactivation()">Cancel</button>
</p>
